import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class PermisosAccionesUnidadInspeccionCamViewModel {
    public Id: number | null;
    public IdAccion: number;
    public IdPerfil: number;
    public IdEstadoUnidadInspeccionCam: number | null;
    public IdTipoSolicitudCam: number | null;
    public Edicion: boolean | null;
}

export class PermisosAccionesUnidadInspeccionCamItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PermisosAccionesUnidadInspeccionCamItemViewModel[];
}

export class PermisosAccionesUnidadInspeccionCamItemViewModel {
    public Id: number;
    public IdAccion: number;
    public IdAccionDescripcion: string;
    public IdModulo: number;
    public IdModuloDescripcion: string;
    public IdPerfil: number;
    public IdPerfilDescripcion: string;
    public IdEstadoUnidadInspeccionCam: number | null;
    public IdEstadoUnidadInspeccionCamDescripcion: string;
    public IdTipoSolicitudCam: number | null;
    public IdTipoSolicitudCamDescripcion: string;
    public Edicion: boolean | null;
}

export class FilterSearchingPermisosAccionesUnidadInspeccionCamViewModel extends FilterSearchingBaseViewModel {
    public Id: number;
    public IdAccion: number;
    public IdAccionDescripcion: string;
    public IdPerfil: number;
    public IdEstadoUnidadInspeccionCam: number | null;
    public IdTipoSolicitudCam: number | null;
    public Edicion: boolean | null;
}
